import React, { useState, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";

import StaffService from "../../../services/staff.service";

import "./scheduled.css";

const ViewSlots = ({ vid }) => {
  const [remove, setRemove] = useState(false);

  const [did, setDid] = useState("");

  const [message, setMessage] = useState("");

  const [staff, setStaff] = useState({
    id: vid,
    first_name: "",
    last_name: "",
    role: "",
    role_id: "", 
    email: "",
    mobile: "",
    role_type: "",
    working_hours: "",
    work_experience: "",
    joining_date: "",
    address: "",
    nationality: "",
    hourly_rate: "",
  });

  const handleRemoveShow = (e) => {
    setRemove(true);
    setDid(e.target.getAttribute("data-bs-target"));
  };

  const handleRemoveClose = () => {
    setRemove(false);
  };

  const getRole = (vid) => {
    StaffService.getStaffBy(vid)
      .then((response) => {
        setStaff(response.data[0]);
        console.log(response.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  useEffect(() => {
    if (vid) {
      getRole(vid);
    }
  }, [vid]);

  const deleteStaff = () => {
    StaffService.remove(did)
      .then((response) => {
        setMessage(response.data.message);
        // window.location.reload();
        setRemove(false);
        console.log(response.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  return (
    <>
      <div className={message ? 'modalMessage active' : 'modalMessage'}>{message}</div>
      <div className="viewModal">
        <h2>Slot Details</h2>
        <div className="staff-details">
          <div className="title">
            <span>Booking ID</span>
          </div>
          <div className="dash">
            <span>-</span>
          </div>
          <div className="text">
            <span>00127</span>
          </div>
        </div>
        <div className="staff-details">
          <div className="title">
            <span>Client Name</span>
          </div>
          <div className="dash">
            <span>-</span>
          </div>
          <div className="text">
            <span>Olive Yew</span>
          </div>
        </div>
        <div className="staff-details">
          <div className="title">
            <span>Course Name</span>
          </div>
          <div className="dash">
            <span>-</span>
          </div>
          <div className="text">
            <span>GMR</span>
          </div>
        </div>
        <div className="staff-details">
          <div className="title">
            <span>Training Type</span>
          </div>
          <div className="dash">
            <span>-</span>
          </div>
          <div className="text">
            <span>AWS</span>
          </div>
        </div>
        <div className="staff-details">
          <div className="title">
            <span>Slot</span>
          </div>
          <div className="dash">
            <span>-</span>
          </div>
          <div className="text">
            <span>1</span>
          </div>
        </div>
        <div className="staff-details">
          <div className="title">
            <span>Date</span>
          </div>
          <div className="dash">
            <span>-</span>
          </div>
          <div className="text">
            <span>15-05-2023</span>
          </div>
        </div>
        <div className="staff-details">
          <div className="title">
            <span>Time</span>
          </div>
          <div className="dash">
            <span>-</span>
          </div>
          <div className="text">
            <span>15:00-16:00</span>
          </div>
        </div>
        <div className="staff-details">
          <div className="title">
            <span>Student</span>
          </div>
          <div className="dash">
            <span>-</span>
          </div>
          <div className="text">
            <span>Alexa S</span>
          </div>
        </div>
        <div className="staff-details">
          <div className="title">
            <span>Instructor</span>
          </div>
          <div className="dash">
            <span>-</span>
          </div>
          <div className="text">
            <span>Teri Dactyl</span>
          </div>
        </div>
        <div className="staff-details">
          <div className="title">
            <span>Supporting Instructor</span>
          </div>
          <div className="dash">
            <span>-</span>
          </div>
          <div className="text">
            <span>Allie Grater, Olive Yew</span>
          </div>
        </div>
        <h2>Booked Assets Details</h2>
        <div className="staff-details">
          <div className="title">
            <span>Simulator</span>
          </div>
          <div className="dash">
            <span>-</span>
          </div>
          <div className="text1">
            <span>Simulator A1</span>
          </div>
          <div className="text2">
            <span>09:00AM-10:00AM</span>
          </div>
        </div>
        <div className="staff-details">
          <div className="title">
            <span>Aircraft</span>
          </div>
          <div className="dash">
            <span>-</span>
          </div>
         <div className="text1">
            <span>Simulator A1</span>
          </div>
          <div className="text2">
            <span>09:00AM-10:00AM</span>
          </div>
        </div>
        <div className="staff-details">
          <div className="title">
            <span>Machine</span>
          </div>
          <div className="dash">
            <span>-</span>
          </div>
          <div className="text1">
            <span>Simulator A1</span>
          </div>
          <div className="text2">
            <span>09:00AM-10:00AM</span>
          </div>
        </div>
        <div className="flex">
          <Button>
            <Link to={"/EditStaff/" + vid}>Edit</Link>
          </Button>
          <Button
            variant="danger"
            onClick={handleRemoveShow}
            id="deleteStaff"
            data-bs-target={vid}
          >
            Delete
          </Button>
        </div>
      </div>
      <Modal show={remove} onHide={handleRemoveClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Delete Staff</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to delete this staff.</p>
          <div className="flex">
            <Button onClick={deleteStaff}>Yes</Button>
            <Button variant="danger" onClick={handleRemoveClose}>
              No
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default ViewSlots;
